// extracted by mini-css-extract-plugin
export default {"circularIndicator":"MatchIndicator-module__circularIndicator___fx6Aj"};